















import { Component, Watch } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import FormBase from '@/mixins/FormBase';
import { Action } from 'vuex-class';
import CropType from '@/core/interfaces/CropType';

@Component({
    components: { FormFooter },
})
export default class CropTypeForm extends FormBase<CropType> {
    @Action('saveCropType')
    saveAction!: (barn: Partial<CropType>) => Promise<CropType>;

    name = '';

    @Watch('initial', { immediate: true })
    setFromInitial(): void {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';
    }

    get parseForm(): Partial<CropType> {
        return {
            ...this.initial,
            id: this.initial?.id || undefined,
            name: this.name,
        };
    }
}

